import { useUserStrategies } from '../../../context/UserStrategies';
import Contribution from '../Contribution';
import { PlaceholderStrategy } from '../../Strategies/Placeholder';
import { t } from 'i18next';

export type TCompareWidgetProps = {
  width: number;
};

export const StrategiesContribution = ({ width }: TCompareWidgetProps) => {
  const { strategies } = useUserStrategies();

  return strategies.length < 2 ? (
    <PlaceholderStrategy
      title={t('placeholders.compareStrategies.title')}
      subtitle={t('placeholders.compareStrategies.subtitle')}
    />
  ) : (
    <Contribution
      height={2}
      loading={() => {}}
      standAlone={false}
      width={width > 4 ? 4 : width}
      isFixedHeight
    />
  );
};
